import {
  Container,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { Link, useSearchParams } from 'react-router-dom'

import Button from '@/components/button'
import { Pagination } from '@/components/pagination'
import { Sorting } from '@/components/sorting'
import { useGetWeedDiagnoses } from '@/hooks/queries/use-get-weed-diagnoses'
import { routes } from '@/routes/config'

import TableSkeleton from '../../components/table-skeleton'
import { OnSubmitSearchParams, Search, SearchType } from './components/search'
import { useStyles } from './styles'
import TableDiagnoses from './table'

const WeedDiagnoses = () => {
  const classes = useStyles()
  const [searchParams, setSearchParams] = useSearchParams()

  const search = searchParams.get('search') || ''
  const searchType = (searchParams.get('searchType') ||
    'demand_name') as SearchType
  const pageLimit = Number(searchParams.get('pageLimit') || 10)
  const lastItem = searchParams.get('lastItem') || ''
  const orderBy = searchParams.get('orderBy') || '-created_at'

  const { data, isFetching, isPreviousData } = useGetWeedDiagnoses({
    pageLimit,
    orderBy,
    lastItem,
    search,
    searchType,
  })

  const isFetchingMore = (isPreviousData && isFetching) || !data

  function handleNewPage(newPage: number) {
    if (isFetchingMore) return

    setSearchParams((prev) => {
      if (newPage > data.page) {
        prev.set('lastItem', data.next)
      } else {
        prev.set('lastItem', data.previous || '')
      }

      return prev
    })
  }

  function handleRowPerPageChange(limit: number) {
    setSearchParams((prev) => {
      prev.set('pageLimit', limit.toString())
      prev.delete('lastItem')
      return prev
    })
  }

  function handleOrderBy(value: string) {
    setSearchParams((prev) => {
      prev.set('orderBy', value)
      prev.delete('lastItem')
      return prev
    })
  }

  function handleSubmitSearch({ search, searchType }: OnSubmitSearchParams) {
    setSearchParams((prev) => {
      prev.delete('lastItem')

      if (!search) {
        prev.delete('search')
        prev.delete('searchType')
        return prev
      }

      prev.set('search', search)
      prev.set('searchType', searchType)
      return prev
    })
  }
  return (
    <Container className={classes.main}>
      <div className={classes.actionBar}>
        <div>
          <Typography variant={'h1'} color='textPrimary'>
            Diagnósticos
          </Typography>
          <Search
            onSubmitSearch={handleSubmitSearch}
            initialSearch={search}
            initialSearchType={searchType}
          />
          <Button
            color='primary'
            className={classes.button}
            to={routes.Demands('register')}
            component={Link}
            role='link'
          >
            <AddIcon /> Novo Diagnóstico
          </Button>
        </div>

        <div>
          <Sorting.Root
            value={orderBy}
            onChange={(e) => handleOrderBy(e.target.value as string)}
          >
            <Sorting.Item value='-created_at'>
              Data de Cadastro (Mais recente)
            </Sorting.Item>
            <Sorting.Item value='created_at'>
              Data de Cadastro (Mais antigo)
            </Sorting.Item>
            <Sorting.Item value='demand_name'>
              Nome do Diagnóstico (A-Z)
            </Sorting.Item>
            <Sorting.Item value='-demand_name'>
              Nome do Diagnóstico (Z-A)
            </Sorting.Item>
            <Sorting.Item value='project_name'>Projeto (A-Z)</Sorting.Item>
            <Sorting.Item value='-project_name'>Projeto (Z-A)</Sorting.Item>
          </Sorting.Root>
          <Pagination
            count={data?.count || 0}
            page={data?.page ? data.page - 1 : 0}
            onPageChange={(_, newPage) => handleNewPage(newPage + 1)}
            onRowsPerPageChange={(e) =>
              handleRowPerPageChange(Number(e.target.value))
            }
            rowsPerPage={pageLimit}
            labelRowsPerPage='Diagnósticos por página:'
          />
        </div>
      </div>
      {isFetchingMore ? (
        <div className={classes.fakeTable}>
          <Table aria-label='collapsible table' padding='none'>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant='body2' color='textSecondary'>
                    Data do cadastro
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2' color='textSecondary'>
                    Nome do diagnóstico
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2' color='textSecondary'>
                    Projeto
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2' color='textSecondary'>
                    Tags
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2' color='textSecondary'>
                    Status
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2' color='textSecondary'>
                    Mais
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
          <TableSkeleton />
        </div>
      ) : (
        <TableDiagnoses diagnoses={data.results} />
      )}
    </Container>
  )
}

export default WeedDiagnoses
